import { ProvinceBlock } from '@/types';

// 获取相邻省份（简化数据）
function getNeighbors(provinceId: string): string[] {
  const neighborMap: Record<string, string[]> = {
    beijing: ['河北', '天津'],
    tianjin: ['北京', '河北'],
    hebei: ['北京', '天津', '山西', '河南', '山东', '辽宁', '内蒙古'],
    shanxi: ['河北', '河南', '陕西', '内蒙古'],
    neimenggu: ['黑龙江', '吉林', '辽宁', '河北', '山西', '陕西', '宁夏', '甘肃'],
    liaoning: ['内蒙古', '吉林', '河北'],
    jilin: ['黑龙江', '辽宁', '内蒙古'],
    heilongjiang: ['内蒙古', '吉林'],
    shanghai: ['江苏', '浙江'],
    jiangsu: ['山东', '安徽', '浙江', '上海'],
    zhejiang: ['江苏', '安徽', '江西', '福建', '上海'],
    anhui: ['江苏', '浙江', '江西', '湖北', '河南', '山东'],
    fujian: ['浙江', '江西', '广东'],
    jiangxi: ['湖北', '湖南', '广东', '福建', '浙江', '安徽'],
    shandong: ['河北', '河南', '安徽', '江苏'],
    henan: ['河北', '山西', '陕西', '湖北', '安徽', '山东'],
    hubei: ['河南', '陕西', '重庆', '湖南', '江西', '安徽'],
    hunan: ['湖北', '重庆', '贵州', '广西', '广东', '江西'],
    guangdong: ['福建', '江西', '湖南', '广西', '海南'],
    guangxi: ['云南', '贵州', '湖南', '广东'],
    hainan: ['广东'],
    chongqing: ['四川', '贵州', '湖南', '湖北', '陕西'],
    sichuan: ['重庆', '贵州', '云南', '西藏', '青海', '甘肃', '陕西'],
    guizhou: ['四川', '重庆', '湖南', '广西', '云南'],
    yunnan: ['西藏', '四川', '贵州', '广西'],
    tibet: ['新疆', '青海', '四川', '云南'],
    shaanxi: ['内蒙古', '山西', '河南', '湖北', '重庆', '四川', '甘肃', '宁夏'],
    gansu: ['新疆', '内蒙古', '宁夏', '陕西', '四川', '青海'],
    qinghai: ['新疆', '甘肃', '四川', '西藏'],
    ningxia: ['内蒙古', '陕西', '甘肃'],
    xinjiang: ['西藏', '青海', '甘肃'],
    hongkong: ['广东'],
    macao: ['广东'],
    taiwan: []
  };
  
  return neighborMap[provinceId] || [];
}

// 获取地理标志（简化数据）
function getLandmarks(provinceId: string): string[] {
  const landmarkMap: Record<string, string[]> = {
    beijing: ['天安门', '故宫', '长城', '颐和园', '天坛'],
    tianjin: ['天津之眼', '古文化街', '五大道', '海河'],
    hebei: ['承德避暑山庄', '秦皇岛', '张家口', '白洋淀'],
    shanxi: ['五台山', '平遥古城', '云冈石窟', '悬空寺'],
    neimenggu: ['呼伦贝尔草原', '响沙湾', '成吉思汗陵', '阿尔山'],
    liaoning: ['沈阳故宫', '大连', '千山', '本溪水洞'],
    jilin: ['长白山', '松花湖', '净月潭', '雾凇岛'],
    heilongjiang: ['哈尔滨冰雪大世界', '五大连池', '镜泊湖', '雪乡'],
    shanghai: ['外滩', '东方明珠', '豫园', '南京路'],
    jiangsu: ['中山陵', '苏州园林', '太湖', '扬州瘦西湖'],
    zhejiang: ['西湖', '千岛湖', '普陀山', '雁荡山'],
    anhui: ['黄山', '九华山', '天柱山', '宏村'],
    fujian: ['武夷山', '鼓浪屿', '土楼', '三坊七巷'],
    jiangxi: ['庐山', '井冈山', '三清山', '滕王阁'],
    shandong: ['泰山', '崂山', '蓬莱阁', '大明湖'],
    henan: ['少林寺', '龙门石窟', '云台山', '开封府'],
    hubei: ['黄鹤楼', '武当山', '神农架', '三峡'],
    hunan: ['张家界', '岳阳楼', '凤凰古城', '衡山'],
    guangdong: ['丹霞山', '开平碉楼', '白云山', '珠江'],
    guangxi: ['桂林山水', '漓江', '阳朔', '德天瀑布'],
    hainan: ['天涯海角', '亚龙湾', '蜈支洲岛', '五指山'],
    chongqing: ['洪崖洞', '大足石刻', '武隆', '磁器口'],
    sichuan: ['九寨沟', '峨眉山', '乐山大佛', '都江堰'],
    guizhou: ['黄果树瀑布', '梵净山', '荔波', '镇远古镇'],
    yunnan: ['丽江古城', '石林', '泸沽湖', '香格里拉'],
    tibet: ['布达拉宫', '珠穆朗玛峰', '纳木错', '大昭寺'],
    shaanxi: ['兵马俑', '华山', '大雁塔', '法门寺'],
    gansu: ['莫高窟', '嘉峪关', '麦积山', '鸣沙山'],
    qinghai: ['青海湖', '塔尔寺', '可可西里', '茶卡盐湖'],
    ningxia: ['沙湖', '贺兰山', '西夏王陵', '沙坡头'],
    xinjiang: ['天山天池', '喀纳斯', '吐鲁番', '那拉提草原'],
    hongkong: ['维多利亚港', '太平山', '迪士尼乐园', '海洋公园'],
    macao: ['大三巴牌坊', '威尼斯人', '妈阁庙', '澳门塔'],
    taiwan: ['阿里山', '日月潭', '太鲁阁', '101大楼']
  };
  
  return landmarkMap[provinceId] || [];
}

// 省份名称到ID的映射（基于阿里云数据）
const PROVINCE_NAME_TO_ID: Record<string, { id: string; shortName: string; capital: string }> = {
  '北京市': { id: 'beijing', shortName: '京', capital: '北京' },
  '天津市': { id: 'tianjin', shortName: '津', capital: '天津' },
  '河北省': { id: 'hebei', shortName: '冀', capital: '石家庄' },
  '山西省': { id: 'shanxi', shortName: '晋', capital: '太原' },
  '内蒙古自治区': { id: 'neimenggu', shortName: '蒙', capital: '呼和浩特' },
  '辽宁省': { id: 'liaoning', shortName: '辽', capital: '沈阳' },
  '吉林省': { id: 'jilin', shortName: '吉', capital: '长春' },
  '黑龙江省': { id: 'heilongjiang', shortName: '黑', capital: '哈尔滨' },
  '上海市': { id: 'shanghai', shortName: '沪', capital: '上海' },
  '江苏省': { id: 'jiangsu', shortName: '苏', capital: '南京' },
  '浙江省': { id: 'zhejiang', shortName: '浙', capital: '杭州' },
  '安徽省': { id: 'anhui', shortName: '皖', capital: '合肥' },
  '福建省': { id: 'fujian', shortName: '闽', capital: '福州' },
  '江西省': { id: 'jiangxi', shortName: '赣', capital: '南昌' },
  '山东省': { id: 'shandong', shortName: '鲁', capital: '济南' },
  '河南省': { id: 'henan', shortName: '豫', capital: '郑州' },
  '湖北省': { id: 'hubei', shortName: '鄂', capital: '武汉' },
  '湖南省': { id: 'hunan', shortName: '湘', capital: '长沙' },
  '广东省': { id: 'guangdong', shortName: '粤', capital: '广州' },
  '广西壮族自治区': { id: 'guangxi', shortName: '桂', capital: '南宁' },
  '海南省': { id: 'hainan', shortName: '琼', capital: '海口' },
  '重庆市': { id: 'chongqing', shortName: '渝', capital: '重庆' },
  '四川省': { id: 'sichuan', shortName: '川', capital: '成都' },
  '贵州省': { id: 'guizhou', shortName: '黔', capital: '贵阳' },
  '云南省': { id: 'yunnan', shortName: '滇', capital: '昆明' },
  '西藏自治区': { id: 'tibet', shortName: '藏', capital: '拉萨' },
  '陕西省': { id: 'shaanxi', shortName: '陕', capital: '西安' },
  '甘肃省': { id: 'gansu', shortName: '甘', capital: '兰州' },
  '青海省': { id: 'qinghai', shortName: '青', capital: '西宁' },
  '宁夏回族自治区': { id: 'ningxia', shortName: '宁', capital: '银川' },
  '新疆维吾尔自治区': { id: 'xinjiang', shortName: '新', capital: '乌鲁木齐' },
  '香港特别行政区': { id: 'hongkong', shortName: '港', capital: '香港' },
  '澳门特别行政区': { id: 'macao', shortName: '澳', capital: '澳门' },
  '台湾省': { id: 'taiwan', shortName: '台', capital: '台北' }
};

// 计算几何体的中心点
const calculateGeometryCenter = (geometry: any): [number, number] => {
  if (!geometry || !geometry.coordinates) {
    return [104, 35]; // 默认中心点
  }
  
  let coordinates: number[][];
  
  if (geometry.type === 'Polygon') {
    coordinates = geometry.coordinates[0];
  } else if (geometry.type === 'MultiPolygon') {
    // 对于多多边形，取第一个多边形的第一个环
    coordinates = geometry.coordinates[0][0];
  } else {
    return [104, 35];
  }
  
  if (!Array.isArray(coordinates) || coordinates.length === 0) {
    return [104, 35];
  }
  
  // 计算边界框中心点
  let minX = Infinity, maxX = -Infinity;
  let minY = Infinity, maxY = -Infinity;
  
  coordinates.forEach((coord: number[]) => {
    const [x, y] = coord;
    minX = Math.min(minX, x);
    maxX = Math.max(maxX, x);
    minY = Math.min(minY, y);
    maxY = Math.max(maxY, y);
  });
  
  return [(minX + maxX) / 2, (minY + maxY) / 2];
};

// 将从阿里云API获取的GeoJSON数据转换为省份数据
export const convertGeoJSONToProvinces = (geoData: any): Omit<ProvinceBlock, 'currentPosition' | 'isPlaced' | 'isLocked'>[] => {
  if (!geoData || !geoData.features) {
    console.warn('GeoJSON数据无效或为空');
    return [];
  }
  
  console.log('开始转换GeoJSON数据，特征数量:', geoData.features.length);
  
  const validProvinces = geoData.features
    .map((feature: any, index: number) => {
      try {
        const provinceName = feature.properties?.name;
        
        // 检查省份名称是否有效
        if (!provinceName || typeof provinceName !== 'string' || provinceName.trim() === '') {
          console.warn(`跳过无效省份数据，索引 ${index}:`, feature.properties);
          return null;
        }
        
        const trimmedName = provinceName.trim();
        const provinceInfo = PROVINCE_NAME_TO_ID[trimmedName];
        
        if (!provinceInfo) {
          console.warn(`未知省份名称: "${trimmedName}"`);
          return null;
        }
        
        // 计算省份中心点
        const center = calculateGeometryCenter(feature.geometry);
        
        return {
          id: provinceInfo.id,
          name: trimmedName,
          shortName: provinceInfo.shortName,
          capital: provinceInfo.capital,
          geoPath: '', // 将由组件动态生成
          correctPosition: { x: center[0], y: center[1] },
          neighbors: getNeighbors(provinceInfo.id),
          landmarks: getLandmarks(provinceInfo.id)
        };
      } catch (error) {
        console.error(`处理省份数据时出错，索引 ${index}:`, error);
        return null;
      }
    })
    .filter(Boolean); // 过滤掉null值
  
  console.log(`成功转换 ${validProvinces.length} 个有效省份数据`);
  return validProvinces;
};

// 默认省份数据（作为备用）
export const DEFAULT_PROVINCES_DATA: Omit<ProvinceBlock, 'currentPosition' | 'isPlaced' | 'isLocked'>[] = [
  {
    id: 'beijing',
    name: '北京市',
    shortName: '京',
    capital: '北京',
    geoPath: '',
    correctPosition: { x: 116.4, y: 39.9 },
    neighbors: getNeighbors('beijing'),
    landmarks: getLandmarks('beijing')
  },
  {
    id: 'shanghai',
    name: '上海市',
    shortName: '沪',
    capital: '上海',
    geoPath: '',
    correctPosition: { x: 121.5, y: 31.2 },
    neighbors: getNeighbors('shanghai'),
    landmarks: getLandmarks('shanghai')
  },
  {
    id: 'guangdong',
    name: '广东省',
    shortName: '粤',
    capital: '广州',
    geoPath: '',
    correctPosition: { x: 113.3, y: 23.1 },
    neighbors: getNeighbors('guangdong'),
    landmarks: getLandmarks('guangdong')
  },
  {
    id: 'sichuan',
    name: '四川省',
    shortName: '川',
    capital: '成都',
    geoPath: '',
    correctPosition: { x: 104.1, y: 30.7 },
    neighbors: getNeighbors('sichuan'),
    landmarks: getLandmarks('sichuan')
  },
  {
    id: 'xinjiang',
    name: '新疆维吾尔自治区',
    shortName: '新',
    capital: '乌鲁木齐',
    geoPath: '',
    correctPosition: { x: 87.6, y: 43.8 },
    neighbors: getNeighbors('xinjiang'),
    landmarks: getLandmarks('xinjiang')
  },
  {
    id: 'tibet',
    name: '西藏自治区',
    shortName: '藏',
    capital: '拉萨',
    geoPath: '',
    correctPosition: { x: 91.1, y: 29.7 },
    neighbors: getNeighbors('tibet'),
    landmarks: getLandmarks('tibet')
  },
  {
    id: 'heilongjiang',
    name: '黑龙江省',
    shortName: '黑',
    capital: '哈尔滨',
    geoPath: '',
    correctPosition: { x: 126.6, y: 45.8 },
    neighbors: getNeighbors('heilongjiang'),
    landmarks: getLandmarks('heilongjiang')
  },
  {
    id: 'hainan',
    name: '海南省',
    shortName: '琼',
    capital: '海口',
    geoPath: '',
    correctPosition: { x: 110.3, y: 20.0 },
    neighbors: getNeighbors('hainan'),
    landmarks: getLandmarks('hainan')
  }
];

// 动态省份数据（将在运行时从API加载）
export let PROVINCES_DATA: Omit<ProvinceBlock, 'currentPosition' | 'isPlaced' | 'isLocked'>[] = DEFAULT_PROVINCES_DATA;

// 更新省份数据的函数
export const updateProvincesData = (newData: Omit<ProvinceBlock, 'currentPosition' | 'isPlaced' | 'isLocked'>[]) => {
  PROVINCES_DATA = newData;
  
  // 更新困难模式的省份列表
  DIFFICULTY_CONFIG.hard.provinces = newData.map(p => p.id);
  
  console.log(`省份数据已更新，包含 ${newData.length} 个省份`);
};

// 难度配置 - 修改为数量配置，支持随机选择
export const DIFFICULTY_CONFIG = {
  easy: {
    provinces: [] as string[], // 将在运行时随机选择8个省份
    count: 8, // 省份数量
    timeLimit: 300, // 5分钟
    hintsAllowed: 5
  },
  medium: {
    provinces: [] as string[], // 将在运行时随机选择15个省份
    count: 15, // 省份数量
    timeLimit: 480, // 8分钟
    hintsAllowed: 3
  },
  hard: {
    provinces: [] as string[], // 将在运行时包含所有省份
    count: 0, // 0表示所有省份
    timeLimit: 900, // 15分钟
    hintsAllowed: 2
  }
};

// 评分配置
export const SCORING_CONFIG = {
  correctPlacement: 10,
  consecutiveBonus: 5,
  wrongPlacement: -3,
  quizCorrect: 20,
  timeBonus: 1, // 每剩余秒数得1分
  hintPenalty: -5
};
